import { render, staticRenderFns } from "./DirectDebitPage.vue?vue&type=template&id=17cb0e96"
import script from "./DirectDebitPage.vue?vue&type=script&lang=ts"
export * from "./DirectDebitPage.vue?vue&type=script&lang=ts"
import style0 from "./DirectDebitPage.vue?vue&type=style&index=0&id=17cb0e96&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports